import {
  GET_DATA_PURGE_DURATION,
  GET_DATA_PURGE_ENROLMENT_STATUS,
  GET_DATA_PURGE_STUDENTS,
  SEARCH_DATA_PURGE_STUDENTS,
  DOWNLOAD_DATA_PURGE_REPORT,
  CHECK_DATA_PURGE_REPORT_AVAILABLE,
  DOWNLOAD_DATA_PURGE_REPORT_CSV,
  DELETE_DATA_PURGE,
  RESET_DATA_PURGE,
  CHECK_STUDENTS_ARE_MARKED_FOR_PURGE,
  DOWNLOAD_DATA_TOBE_PURGED_REPORT,
  LOGOUT
} from '../action-types'
import {
  SET_DATA_PURGE_DURATION,
  SET_DATA_PURGE_ENROLMENT_STATUS,
  SET_DATA_PURGE_LOADING,
  SET_DATA_PURGE_STUDENTS,
  SET_SELECTED_DURATION,
  SET_SELECTED_ENROLMENT_STATUS,
  SET_DATA_PURGE_SEARCH,
  SET_DATA_PURGE_SEARCH_DISPLAY,
  RESET_DATA_PURGE_STUDENTS,
  SET_DATA_PURGE_PAGE_NUMBER,
  SET_DATA_PURGE_REPORT_LOADING,
  SET_DATA_PURGE_OUTPUT_LOADING,
  RESET_PURGE_FILTER_AND_SEARCH,
  SET_DATA_PURGE_FIRST_DELETE_CONFIRMATION,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_DATA_PURGE_SENDING,
  SET_HAS_SCHEDULED_TIME,
  SET_DATA_PURGE_SCHEDULE
} from '../mutation-types'
import server from '../server'
import FileSaver from 'file-saver'
import axios from 'axios'
import { informationTexts } from './information'

const state = {
  firstAttempt: true,
  firstConfirmation: true,
  loading: false,
  sending: false,
  report_downloading: false,
  output_downloading: false,
  feed_loading: true,
  feed_running: true,
  students: [],
  searchString: '',
  searchStringDisplay: '',
  enrolmentStatus: [],
  duration: [],
  currentPage: 0,
  totalElements: 0,
  pageSize: 10,
  totalPages: 0,
  selectedDuration: 0,
  selectedEnrolment: [],
  isScheduled: false,
  schedule: {}
}

const mutations = {
  [SET_DATA_PURGE_LOADING] (state, value) {
    state.loading = value
  },
  [SET_DATA_PURGE_SENDING] (state, value) {
    state.sending = value
  },
  /* [SET_DATA_PURGE_FEED_LOADING] (state, value) {
    state.feed_loading = value
  }, */
  [SET_DATA_PURGE_REPORT_LOADING] (state, value) {
    state.report_downloading = value
  },
  [SET_DATA_PURGE_OUTPUT_LOADING] (state, value) {
    state.output_downloading = value
  },
  [SET_DATA_PURGE_DURATION] (state, value) {
    state.duration = value
  },
  [SET_SELECTED_DURATION] (state, value) {
    state.selectedDuration = value
  },
  [SET_SELECTED_ENROLMENT_STATUS] (state, value) {
    state.selectedEnrolment = value
  },
  [SET_DATA_PURGE_SEARCH] (state, value) {
    state.searchString = value
  },
  [SET_DATA_PURGE_SEARCH_DISPLAY] (state, value) {
    state.searchStringDisplay = value
  },
  [SET_DATA_PURGE_ENROLMENT_STATUS] (state, value) {
    state.enrolmentStatus = value.map((item, id) => ({
      ...item, id
    }))
  },
  [SET_DATA_PURGE_STUDENTS] (state, data) {
    state.students = data.content
    state.totalElements = data.totalElements
    state.loading = false
    state.lastPage = data.lastPage
    state.totalPages = Math.ceil(data.totalElements / state.pageSize)
    state.firstAttempt = false
  },
  [RESET_DATA_PURGE_STUDENTS] (state) {
    state.students = []
    state.totalElements = 0
    state.loading = false
    state.currentPage = 0
    state.lastPage = false
  },
  [RESET_PURGE_FILTER_AND_SEARCH] (state) {
    state.searchString = ''
    state.searchStringDisplay = ''
    state.selectedDuration = 0
    state.selectedEnrolment = []
    state.students = []
    state.firstAttempt = true
  },
  [SET_DATA_PURGE_PAGE_NUMBER] (state, number) {
    state.currentPage = number
  },
  [SET_DATA_PURGE_FIRST_DELETE_CONFIRMATION] (state, value) {
    state.firstConfirmation = value
  },
  /* [SET_FEED_IS_RUNNING] (state, value) {
    state.feed_running = value
  }, */
  [SET_HAS_SCHEDULED_TIME] (state, value) {
    state.isScheduled = value
  },
  [SET_DATA_PURGE_SCHEDULE] (state, value) {
    state.schedule = value
  }
}

const actions = {
  [LOGOUT] (context) {
    context.commit(RESET_PURGE_FILTER_AND_SEARCH)
    context.commit(SET_DATA_PURGE_FIRST_DELETE_CONFIRMATION, true)
  },
  [GET_DATA_PURGE_STUDENTS] ({ commit, state }) {
    const actionData = { action: GET_DATA_PURGE_STUDENTS }
    const url = `/core/purge/student/filter`
    commit(SET_DATA_PURGE_LOADING, true)
    const request = {
      pageNumber: state.currentPage,
      pageSize: state.pageSize,
      searchString: state.searchString,
      enrolmentStatus: state.selectedEnrolment,
      purgeDurationId: state.selectedDuration,
      sortBy: 'LASTUPDATED_DATETIME'
    }
    server.postReplayable(url, request, actionData)
      .then(result => {
        commit(SET_DATA_PURGE_STUDENTS, result.data)
        commit(SET_DATA_PURGE_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_DATA_PURGE_LOADING, false)
      })
  },
  [GET_DATA_PURGE_ENROLMENT_STATUS] ({ commit }) {
    const actionData = { action: GET_DATA_PURGE_ENROLMENT_STATUS }
    const url = `/core/enrolmentstatus/all`
    server.getReplayable(url, actionData)
      .then(result => {
        commit(SET_DATA_PURGE_ENROLMENT_STATUS, result.data)
      })
      .catch(error => {
        console.error(error)
      })
  },
  [GET_DATA_PURGE_DURATION] ({ commit }) {
    const actionData = { action: GET_DATA_PURGE_DURATION }
    const url = `/core/purge/duration/all`
    server.getReplayable(url, actionData)
      .then(result => {
        commit(SET_DATA_PURGE_DURATION, result.data)
      })
      .catch(error => {
        console.error(error)
      })
  },
  [SEARCH_DATA_PURGE_STUDENTS] ({ commit, dispatch, state }, searchString) {
    const previousSearchString = state.searchString
    const currentSearchString = searchString.trim().length > 2 ? searchString.trim() : null

    commit(SET_DATA_PURGE_SEARCH, currentSearchString)
    commit(SET_DATA_PURGE_SEARCH_DISPLAY, searchString)
    if (currentSearchString !== previousSearchString) {
      commit(RESET_DATA_PURGE_STUDENTS)
      dispatch(GET_DATA_PURGE_STUDENTS)
    }
  },
  [DOWNLOAD_DATA_PURGE_REPORT] ({ commit, rootState, state, dispatch }) {
    const actionData = { action: DOWNLOAD_DATA_PURGE_REPORT }
    const url = `/core/report/purge/student`
    const request = {
      searchString: state.searchString,
      enrolmentStatus: state.selectedEnrolment,
      purgeDurationId: state.selectedDuration,
      pageNumber: state.currentPage,
      pageSize: state.pageSize,
      sortBy: 'LASTUPDATED_DATETIME'
    }
    if (!state.output_downloading) {
      commit(SET_DATA_PURGE_OUTPUT_LOADING, true)
      server.postReplayable(url, request, actionData)
        .then(result => {
          let pollingFrequency = rootState.config.reportPollingDuration / rootState.config.reportPollingFrequency
          let pollingCount = 1
          dispatch(CHECK_DATA_PURGE_REPORT_AVAILABLE, {
            pollingFrequency: pollingFrequency,
            pollingCount: pollingCount,
            reportId: result.data,
            reportType: 'PurgeCountReport'
          })
        })
        .catch(error => {
          console.error(error)
        })
    }
  },
  [DOWNLOAD_DATA_TOBE_PURGED_REPORT] ({rootState, commit, dispatch}) {
    commit(SET_DATA_PURGE_REPORT_LOADING, true)
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/report/purge/mark/student`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: DOWNLOAD_DATA_TOBE_PURGED_REPORT}
    })
      .then((res) => {
        let pollingFrequency = rootState.config.reportPollingDuration / rootState.config.reportPollingFrequency
        let pollingCount = 1
        dispatch(CHECK_DATA_PURGE_REPORT_AVAILABLE, {
          pollingFrequency: pollingFrequency,
          pollingCount: pollingCount,
          reportId: res.data,
          reportType: 'PurgeStudentReport'
        })
      })
      .catch((err) => {
        console.log(`Error while trying to download student purge report`)
        console.error(err)
      })
  },
  [CHECK_DATA_PURGE_REPORT_AVAILABLE] ({commit, dispatch, rootState, state}, reportObject) {
    const actionData = { action: CHECK_DATA_PURGE_REPORT_AVAILABLE }
    const url = `/core/report/available/${reportObject.reportId}`
    server.getReplayable(url, actionData)
      .then(result => {
        if (!result.data && reportObject.pollingCount !== reportObject.pollingFrequency) {
          let pollingTimeout = rootState.config.reportPollingFrequency
          setTimeout(() => {
            dispatch(CHECK_DATA_PURGE_REPORT_AVAILABLE, {
              pollingFrequency: reportObject.pollingFrequency,
              pollingCount: reportObject.pollingCount + 1,
              reportId: reportObject.reportId,
              reportType: reportObject.reportType
            })
          }, pollingTimeout)
        } else {
          dispatch(DOWNLOAD_DATA_PURGE_REPORT_CSV, {reportId: reportObject.reportId, reportType: reportObject.reportType})
        }
      })
      .catch(error => {
        console.error(error)
      })
  },
  [DOWNLOAD_DATA_PURGE_REPORT_CSV] ({commit, rootState, state}, reportObject) {
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/report/download/${reportObject.reportId}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: {action: DOWNLOAD_DATA_PURGE_REPORT_CSV},
      responseType: 'blob'
    }).then(res => {
      const name = reportObject.reportType + `.csv`
      FileSaver.saveAs(res.data, name)
      commit(SET_DATA_PURGE_REPORT_LOADING, false)
      commit(SET_DATA_PURGE_OUTPUT_LOADING, false)
    }).catch(err => {
      console.error(err)
      console.log(`Failed to download the Purge Report`)
      commit(SET_DATA_PURGE_REPORT_LOADING, false)
      commit(SET_DATA_PURGE_OUTPUT_LOADING, false)
    })
  },
 /* [CHECK_FEED_IS_RUNNING] ({ commit }) {
    const actionData = { action: CHECK_FEED_IS_RUNNING }
    const url = `/core/connect/feed/running`
    commit(SET_DATA_PURGE_FEED_LOADING, true)
    server.getReplayable(url, actionData)
      .then(result => {
        commit(SET_FEED_IS_RUNNING, result.data)
        setTimeout(() => {
          commit(SET_DATA_PURGE_FEED_LOADING, false)
        }, 1000)
      })
      .catch(error => {
        console.error(error)
        commit(SET_FEED_IS_RUNNING, true)
        setTimeout(() => {
          commit(SET_DATA_PURGE_FEED_LOADING, false)
        }, 1000)
      })
  }, */
  async [DELETE_DATA_PURGE] ({ commit, dispatch, state }) {
    const actionData = { action: DELETE_DATA_PURGE }
    const url = `/core/purge`
    const request = {
      searchString: state.searchString,
      enrolmentStatus: state.selectedEnrolment,
      purgeDurationId: state.selectedDuration,
      pageNumber: state.currentPage,
      pageSize: state.pageSize,
      sortBy: 'LASTUPDATED_DATETIME'
    }
    await server.postReplayable(url, request, actionData)
      .then(result => {
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.DATA_PURGE_STARTED)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(RESET_DATA_PURGE_STUDENTS)
        commit(RESET_PURGE_FILTER_AND_SEARCH)
        commit(SET_DATA_PURGE_FIRST_DELETE_CONFIRMATION, true)
        dispatch(CHECK_STUDENTS_ARE_MARKED_FOR_PURGE)
      })
      .catch(error => {
        console.error(error)
      })
  },
  [CHECK_STUDENTS_ARE_MARKED_FOR_PURGE] ({ commit }) {
    const actionData = { action: CHECK_STUDENTS_ARE_MARKED_FOR_PURGE }
    const url = `/core/purge/requested`
    server.getReplayable(url, actionData)
      .then(result => {
        if (result.data) {
          commit(SET_HAS_SCHEDULED_TIME, true)
          commit(SET_DATA_PURGE_SCHEDULE, result.data)
        } else {
          commit(SET_HAS_SCHEDULED_TIME, false)
        }
      })
      .catch(error => {
        console.error(error)
      })
  },
  [RESET_DATA_PURGE] ({ commit, state }, request) {
    const actionData = { action: RESET_DATA_PURGE }
    const url = `/core/purge/reset`
    commit(SET_DATA_PURGE_SENDING, true)
    server.putReplayable(url, request, actionData)
      .then(result => {
        commit(RESET_DATA_PURGE_STUDENTS)
        commit(RESET_PURGE_FILTER_AND_SEARCH)
        commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.DATA_PURGE_RESET)
        commit(SET_INFORMATION_SNACKBAR_STATE, true)
        commit(SET_DATA_PURGE_SENDING, false)
        commit(SET_HAS_SCHEDULED_TIME, false)
      })
      .catch(error => {
        console.error(error)
        commit(SET_DATA_PURGE_SENDING, false)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dataPurge.js